import { gql } from "@apollo/client";

export const GET_ALL_EVENTS = gql`
  query GetAllEvents($paginationArgs: IPaginationArgs!) {
    getAllEvents(paginationArgs: $paginationArgs) {
      accessType
      creator {
        email
        firstName
        name
      }
      creatorId
      date
      description
      eventType
      image
      location
      price
      time
      title
      id
    }
  }
`;

export const GET_SINGLE_EVENT = gql`
  query GetEvent($getEventId: String!) {
  getEvent(id: $getEventId) {
    accessType
    creatorId
    date
    description
    eventType
    id
    image
    location
    price
    time
    title
  }
}
`;

export const PURCHASE_COURSE = gql`
query PurchaseCourse($courseId: String!) {
  purchaseCourse(courseId: $courseId) {
    message
    url
    isItemPurchased
  }
}
`;

export const ATTEND_EVENT = gql `
  query AttendEvent($eventId: String!) {
  attendEvent(eventId: $eventId)
}
`